import React from 'react';
import { Alert, AlertTitle, Typography } from '@mui/material';
import { PhotoCamera, Info } from '@mui/icons-material';

interface MobileCameraBannerProps {
  isMobile: boolean;
}

export const MobileCameraBanner: React.FC<MobileCameraBannerProps> = ({ isMobile }) => {
  // Показываем баннер только на мобильных устройствах
  if (!isMobile) {
    return null;
  }

  return (
    <Alert 
      severity="info" 
      icon={<PhotoCamera />}
      sx={{ mb: 2 }}
    >
      <AlertTitle>Mobile Camera Access</AlertTitle>
      <Typography variant="body2">
        To take photos directly from your camera, please allow browser access to your camera when prompted. 
        You can also upload existing photos from your gallery.
      </Typography>
    </Alert>
  );
};
